"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgFlame = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_FLAME", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "m6.419.005 1.288 1.288C8.935 2.52 9.477 4.409 9.734 5.82l.009.05c.127-.23.234-.463.308-.687l.512-1.535 1.144 1.144C13.392 6.478 14 8.232 14 10c0 2.01-.729 3.546-1.908 4.568C10.937 15.57 9.438 16 8 16c-1.444 0-2.83-.435-3.866-1.39C3.086 13.642 2.5 12.234 2.5 10.5c0-1.8.769-3.017 1.503-4.18l.027-.042.008-.012c.737-1.168 1.527-2.419 1.986-4.483L6.419.005ZM8 8.5v-.036l-.003-.13a15.267 15.267 0 0 0-.23-2.155 10.636 10.636 0 0 0-.469-1.765c-.487 1.206-1.06 2.114-1.555 2.897l-.023.035C4.963 8.546 4.5 9.322 4.5 10.5c0 1.266.414 2.108.99 2.64.59.545 1.454.86 2.51.86 1.062 0 2.063-.32 2.783-.943C11.479 12.453 12 11.49 12 10c0-.88-.2-1.766-.792-2.68-.204.321-.416.611-.606.856a13.079 13.079 0 0 1-.892 1.028l-.003.003L8 10.914V8.5Z" }))); };
exports.default = SvgFlame;
